import WidgetModule from "@eisinc/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPlaceOrderButton";

export * from "@eisinc/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPlaceOrderButton";

export default WidgetModule;
